import { FlightSegment } from "@/src/types/flight"
import { Box } from "@mui/material"




const SegmentLine = ({ segment }: { segment: FlightSegment }) => {
    const { departure, arrival } = segment || {}
    const departureTime = new Date(departure.time)
    const arrivalTime = new Date(arrival.time)

    return (
        <Box
            sx={{
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                mr: 2,
                minWidth: '16px'
            }}
        >
            {/* Departure dot */}
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '32px'
                }}
            >
                <Box
                    sx={{
                        width: 8,
                        height: 8,
                        borderRadius: '50%',
                        backgroundColor: '#9ca3af'
                    }}
                />
            </Box>

            {/* Connecting line */}
            <Box
                sx={{
                    position: 'absolute',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    top: '20px',
                    bottom: '28px',
                    width: '2px',
                    backgroundColor: '#d1d5db',
                    zIndex: 0
                }}
            />

            {/* Arrival dot */}
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mt: 'auto',
                    height: '48px'
                }}
            >
                <Box
                    sx={{
                        width: 8,
                        height: 8,
                        borderRadius: '50%',
                        backgroundColor: '#9ca3af'
                    }}
                />
            </Box>
        </Box>
    )
}


export default SegmentLine